import { useContext, useState } from "react";
import Paragraph from "../../../elements/p/Paragraph";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import { toast } from "react-toastify";
import { unsaveProduct } from "../../../../api/users/usersApi";

const UnsaveProduct = () => {
  //context section
  const { onClose, modalParams } = useContext(modalContext);
  const { currentAdmin } = useContext(currentAdminContext);

  //state variables
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //some handlers
  const handleUnsaveProduct = async () => {
    //start loading
    setLoading(true);

    const { data, error } = await unsaveProduct(
      currentAdmin,
      modalParams.productId
    );

    if (error) {
      setError(error);
      return setLoading(false);
    }

    setLoading(false);
    onClose();
    toast.success("Article supprimé de vos favoris", { theme: "colored" });
  };

  return (
    <div className="w-full">
      <Paragraph>
        êtes vous sûre de vouloir retirer cet article de votre liste de vos
        favoris ?
      </Paragraph>
      <div className="mt-4 flex items-center">
        <ButtonAction
          size="small"
          loading={loading}
          onClick={() => handleUnsaveProduct()}
        >
          Retirer
        </ButtonAction>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>

      <span className="mt-1 font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </div>
  );
};

export default UnsaveProduct;
